import React, { useEffect } from 'react';
import MetricsCardWrap from '../../components/MetricsCardWrap';
import { IMarkDownCardProps } from './type';
import { dynamicString } from '@home/utils/dynamicString';
import './index.scss';
import ReactMarkdown from 'react-markdown';
import gfm from 'remark-gfm';
import breaks from 'remark-breaks';
import rehypeRaw from 'rehype-raw';
import Abnormal from '../Abnormal';


const MarkDownCard = (props: IMarkDownCardProps) => {
  const {
    titleEn,
    titleCn,
    subtitleEn,
    subtitleCn,
    icon,
    titleIcon,
    imgUrl,
    link,
    tipsEn,
    tipsCn,
    isIconTips,
    contentHeader,
    contentFooter,
    style,
    className,
    children,
    content,
    loading,
    error,
    data: propsData,
    dataKey= "ai_summary",
    updateDate,
    changeData,
    linkOpenInNewWindow = false,
    windowFeatures= 'noopener,noreferrer',
    infoType,
    htmlKey= "html_format",
  } = props;
  const data = propsData?.[dataKey];

  // 设置页面顶部时间
  useEffect(() => {
    if (updateDate) {
      changeData('subtitle', (dynamicString(updateDate, data))|| "");
    }
  }, [updateDate, data]);

  // 设置点击连接打开新窗口
  const LinkRenderer = ({ href, children, ...props }: any) => {
    const handleClick = (e: React.MouseEvent) => {
      if (linkOpenInNewWindow && href) {
        e.preventDefault();
        window.open(
          href, 
          '_blank', 
          windowFeatures || 'noopener,noreferrer'
        );
      }
    };

    return (
      <a 
        href={href} 
        {...props}
        onClick={handleClick}
        target={linkOpenInNewWindow ? '_blank' : undefined}
        rel={linkOpenInNewWindow ? 'noopener noreferrer' : undefined}
      >
        {children}
        {/* <img className='dbd-markdown-card-hyperlink-icon' src={hyperlink} alt="hyperlink" /> */}
      </a>
    );
  };

  return (
    <MetricsCardWrap
      titleCn={dynamicString(titleCn, propsData)}
      titleEn={dynamicString(titleEn, propsData)}
      className={className}
      style={style}
      link={link}
      tipsEn={dynamicString(tipsEn || '', propsData)}
      tipsCn={dynamicString(tipsCn || '', propsData)}
      icon={icon}
      titleIcon={titleIcon}
      imgUrl={imgUrl}
      isIconTips={isIconTips}
      subtitleEn={dynamicString(subtitleEn || '', propsData)}
      subtitleCn={dynamicString(subtitleCn || '', propsData)}
      contentHeader={contentHeader}
      contentFooter={contentFooter}
    >
      <Abnormal
        isLoading={loading || data?.loading}
        isError={error || data?.errorMsg}
        isNoData={!data?.data}
        className='dbd-markdown-card-abnormal'
        component={
          (dynamicString(infoType, data) !== htmlKey) ? (
            <ReactMarkdown
              className="dbd-markdown-card-content" 
              skipHtml={false}
              rehypePlugins={[rehypeRaw]}
              remarkPlugins={[gfm, breaks]}
              components={{
                a: LinkRenderer
              }}
            >
              {dynamicString(content, data)}
            </ReactMarkdown>
          ) : (
            <div 
              className="dbd-markdown-card-content"
              dangerouslySetInnerHTML={{ 
                __html: dynamicString(content, data) 
              }}
            />
          )
        }
      />
      {children}
    </MetricsCardWrap>
  );
};

export default MarkDownCard;